import { ModalM } from "@common/components/modal/ModalM"
import { FormStepper } from "@common/components/stepper/FormStepper"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import React, { useContext, useEffect } from "react"
import { View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import { connect, useSelector } from "react-redux"

const FormStepperModal = (props) => {
    const {
        visible,
        navigation,
        setVisible,
        formData,
        track = true,
        setFormValues = () => {},
        formValues,
        initialGetService = null,
        initialGetRouteParams = null,
        submitService,
        submitRouteParams = null,
        submitSuccessMessage = null,
        submitSuccessCallback = null,
        submitButtonText = "Terminer",
        submitButtonColor = theme.colors.success,
        submitAdditionalData = {},
        submitErrorCalback = () => {},
        defaultValues = {},
        transformSubmitData = (data) => data,
        // Forwarded to FormStepper — mirror our formValues into RHF's
        // internal _formValues so that `goToNextStep`'s
        // `setFormValues({...control._formValues})` doesn't clobber state
        // that custom steps wrote directly to formValues.
        syncFormValues = false,
    } = props

    const submitted = useSelector(
        (state) => state.api?.[submitService?.name]?.request
    )
    const error = useSelector((state) => state.api[submitService?.name]?.error)

    const dimensions = useContext(DimensionsContext)

    useApiStatus(
        submitService, // api service
        submitSuccessMessage ?? "", // success message on toast (string or null)
        false, // error message on toast (true) or keep it in redux state (false)
        () => {
            setVisible(false)
            submitSuccessCallback?.()
        },
        submitErrorCalback
    )

    useApiStatus(
        initialGetService, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {},
        () => {
            setVisible(false)
        }
    )

    const initialGetRequest = useSelector(
        (state) => state.api?.[initialGetService?.name]?.request
    )

    useEffect(() => {
        if (initialGetService && visible) {
            props.apiRequest(initialGetService, initialGetRouteParams ?? {})
        }
        return () => {}
    }, [visible])

    return (
        <ModalM
            visible={visible}
            onDismiss={() => setVisible(false)}
            style={{ height: "90%", width: dimensions?.width }}
        >
            <View
                style={{
                    flex: 1,
                    borderRadius: 10,
                    paddingTop: 10,
                    paddingBottom: 10,
                    backgroundColor: theme.colors.whiteAlmost,
                }}
            >
                {initialGetRequest ? (
                    <ActivityIndicator
                        animating={true}
                        style={{
                            marginTop: 50,
                        }}
                        size="large"
                        color={theme.colors.primary}
                    />
                ) : (
                    <FormStepper
                        navigation={navigation}
                        noNavigation={true}
                        track={track}
                        formData={formData?.filter((x) => !x.is_masked)}
                        champion={null}
                        setFormValues={setFormValues}
                        formValues={formValues}
                        defaultValues={defaultValues}
                        syncFormValues={syncFormValues}
                        onSubmit={(data) => {
                            props.apiRequest(
                                submitService,
                                submitRouteParams ?? {},
                                {
                                    ...submitAdditionalData,
                                    ...transformSubmitData(data),
                                }
                            )
                        }}
                        submitted={submitted}
                        previousRouteName={""}
                        submittedMessage={""}
                        serverError={error}
                        submitButtonText={submitButtonText}
                        submitButtonColor={submitButtonColor}
                        exitHandler={() => setVisible(false)}
                    />
                )}
            </View>
        </ModalM>
    )
}

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormStepperModal)
